export const faqs = [
  {
    question: 'What exactly is included?',
    answer:
      'One complete 26-week training-plan book organized into six training blocks, with three scheduled sessions per week (78 complete workouts), plus five bonus resources.',
  },
  {
    question: 'Are the workouts fully written?',
    answer:
      'Yes. Sessions include exercise prescriptions, sets, reps, work and rest periods, timing, equipment requirements, and progression guidance.',
  },
  {
    question: 'Who is this pack for?',
    answer:
      'HYROX instructors, gym instructors, and fitness instructors who want structured training plans they can use with their students.',
  },
  {
    question: 'What level are the sessions?',
    answer:
      'Every session includes Foundation and Standard options, and the Mixed-Level Class Toolkit helps you organize participants with different abilities. Choose the appropriate workload for your group.',
  },
  {
    question: 'Do I need every piece of HYROX equipment?',
    answer:
      'Equipment requirements vary by session. The Limited-Equipment Workout Pack provides 20 alternative sessions and replacement guidance. Substitutions train related qualities but are not exact competition equivalents.',
  },
  {
    question: 'Is this a physical book?',
    answer: 'No. It is a digital product in PDF format that you can view on your device or print.',
  },
  {
    question: 'How do I receive it?',
    answer: 'It is a downloadable digital product. You get the PDF files after completing your purchase at checkout.',
  },
  {
    question: 'What currency do I pay in?',
    answer: 'The price is 19 USD. You are charged the equivalent in your local currency at checkout.',
  },
  {
    question: 'Is there a guarantee?',
    answer:
      'Yes. You have a 10-day guarantee. If the pack isn’t right for your classes, contact the store within 10 days of your purchase to request a refund.',
  },
  {
    question: 'Can I follow the program on my own?',
    answer: 'The pack also includes guidance for independent trainees with basic gym and running experience.',
  },
  {
    question: 'Is it an official HYROX product?',
    answer:
      'No. This is an independent training resource, not affiliated with or endorsed by HYROX. It does not provide coaching certification.',
  },
];
